import { render, staticRenderFns } from "./WellbeingHotspot.vue?vue&type=template&id=4a31ad21&"
import script from "./WellbeingHotspot.vue?vue&type=script&lang=js&"
export * from "./WellbeingHotspot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports